module.exports = __webpack_public_path__ + "static/media/SWF.534ba9da.svg";